import * as React from "react";
import type { SVGProps } from "react";
const SvgFullscreenOnIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    className="fullscreen_on_icon_svg__icon"
    viewBox="0 0 1024 1024"
    {...props}
  >
    <path
      fill="currentColor"
      d="M213.333 256A42.667 42.667 0 0 1 256 213.333h170.667a42.667 42.667 0 1 1 0 85.334h-67.67l97.835 97.834a42.667 42.667 0 0 1-60.33 60.331l-97.835-97.835v67.67a42.667 42.667 0 1 1-85.334 0V256zM798.08 798.293A42.539 42.539 0 0 1 768 810.667H597.333a42.667 42.667 0 1 1 0-85.334h67.67L567.168 627.5a42.667 42.667 0 0 1 60.33-60.331l97.835 97.835v-67.67a42.667 42.667 0 1 1 85.334 0V768a42.539 42.539 0 0 1-12.374 30.08l-.213.17zm12.587-627.626a42.667 42.667 0 0 1 42.666 42.666v597.334a42.667 42.667 0 0 1-42.666 42.666H213.333a42.667 42.667 0 0 1-42.666-42.666V213.333a42.667 42.667 0 0 1 42.666-42.666h597.334zM213.333 85.333a128 128 0 0 0-128 128v597.334a128 128 0 0 0 128 128h597.334a128 128 0 0 0 128-128V213.333a128 128 0 0 0-128-128H213.333z"
    />
  </svg>
);
export default SvgFullscreenOnIcon;
